import r from "../managers/braze-instance.js";
import { logger as N } from "../../shared-lib/index.js";
export function destroy() {
  N.info("Destroying Braze instance"), r.destroy(!0);
}
